import React from 'react';
import Migration from './Migration';
export default function MigrationDevice() {
    return <Migration url={'device'} />
};

